<template>
  <div class="welcome-container">
    <h1>🎨 280 handpicked colors</h1>
    <p>
      Flat UI Colors 2 features 13 more color palettes. Collaborating with 13 designers around the world, a total set of 280 colors are on your command for COPY / PASTE for your next project, design, presentation.
    </p>
    <a href="javascript:;" class="close" @click.prevent="close"></a>
  </div>
</template>

<script>
export default {
  name: "Welcome",
  components: {},
  data() {
    return {};
  },
  methods: {
    close: function(){
      this.$ga.event('welcome', 'close');
      this.$emit('closeWelcome');
    }
  }
};
</script>
<style lang="scss" scoped>
.welcome-container {
  display: block;
  width: 100%;
  float: left;
  background: #fff;
  color: #000;
  border-radius: 4px;
  padding: 18px;
  box-sizing: border-box;
  margin-bottom: 40px;
  position: relative;
  float: left;
  h1 {
    font-size: 32px;
    letter-spacing: 1.2px;
    margin-bottom: 20px;
    width: 100%;
    display: block;
    float: left;
  }
  p {
    font-size: 18px;
    line-height: 27px;
    letter-spacing: 1px;
    margin-bottom: 10px;
    display: block;
    float: left;
    width: 100%;
  }
  .close {
    background: #000;
    color: #fff;
    display: block;
    position: absolute;
    width: 20px;
    height: 20px;
    border-radius: 10px;
    right: 12px;
    top: 10px;
    transition: all 0.2s;
    &::before {
      content: "+";
      font-size: 20px;
      width: 20px;
      height: 20px;
      line-height: 16px;
      // background: red;
      text-align: center;
      position: relative;
      display: inline-block;
      font-weight: bold;
      transform: rotate(45deg);
      // font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif;
    }
    &:active {
      transform: scale(0.8);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Welcome.vue